import theme from '../base'

const menu = {
  MuiMenu: {
    styleOverrides: {
      list: {
        width: 'calc(100% + 32px)',
        margin: theme.spacing(-1.5, -2),
        color: theme.palette.neutral.main,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingTop: 10,
        paddingBottom: 10,

        '&.Mui-selected': {
          backgroundColor: 'transparent',
          color: theme.palette.primary.main,

          '&:hover': {
            backgroundColor: theme.palette.neutral.lightest,
          },
        },
      },
    },
  },
}

export default menu
